const PREFECTURE = '兵庫県';
const CITY = '神戸市';
const WARD = '灘区';
const MUNICIPALITY = `${CITY}${WARD}`;
const COUNTRY_CODE = 'JP';
const FREE_SPACE_STREET = '大内通2丁目1番5号';
const MONTE_SPACE_STREET = '灘北通4丁目6番8号';

export const Address = {
  PREFECTURE,
  CITY,
  WARD,
  MUNICIPALITY,
  COUNTRY_CODE,
  FREE_SPACE_STREET,
  MONTE_SPACE_STREET,
  FREE_SPACE: `${MUNICIPALITY}${FREE_SPACE_STREET}`,
  MONTE_SPACE: `${MUNICIPALITY}${MONTE_SPACE_STREET}`,
} as const;
